<template>
    <div class="th-width-block" :style="{float: this.column.type === 'number' ? 'right' : 'left', width: '100%'}">
        <div :class="[
            'table-th',
            this.dir !== null ? 'active' : '',
            this.column.order ? 'has-order': ''
        ]" @click="this.$emit('change:order', this.column.orderColumn ?? this.column.key)">
            <div class="info" :style="{
                float: this.column.type === 'number' ? 'right' : 'left',
                'white-space': 'nowrap',
                'max-width': '100%',
                'overflow': 'hidden',
                'text-overflow': 'ellipsis'
            }">
                <slot></slot>
            </div>
            <div class="order" v-if="this.column.order">
                <i v-if="this.dir === null" class="icon-arrow-down8" style="color: #dfdfdf;"></i>
                <i v-else-if="this.dir === 'desc'" class="icon-arrow-down8"></i>
                <i v-else-if="this.dir === 'asc'" class="icon-arrow-up8"></i>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "FetchTh",
    props: {
        column: {
            required: true,
            type: Object
        },
        dir: {
            type: String,
            default: null
        }
    },
    emits: ['change:order']
}
</script>
<style scoped>
.table-th.has-order.has-order {
    display: flex;
    column-gap: 10px;
    width: fit-content;
    padding: 5px 0;
    transition: all 0.2s ease-in-out;
    border-radius: 2px;
    cursor: pointer;
    max-width: 100%;
}

.table-th.has-order.active, .table-th.has-order:hover {
    padding: 5px 10px;
    background: #f5f5f5;
}

.table-th.has-order > .order{
    opacity: 0;
    transition: all 0.2s ease-in-out;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
}

.table-th.has-order.active > .order, .table-th.has-order:hover > .order{
    opacity: 1;
}

.table-th.has-order > .order > i{
    font-size: 12px;
}
</style>
